import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';

import { ClientService, SessionService } from '../../../../services';
import { ClientTreeItem, buildClientTree } from '../../../../services/client/client-tree';
import { FilterComponent } from '../../../form';

type SelectableMapped = ClientTreeItem;

@Component({
  selector: 'dmb-select-client',
  templateUrl: './select-client.component.html',
  styleUrls: ['./select-client.component.scss', '../../modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatCardContent, FilterComponent],
})
export class SelectClientComponent {
  sessionService = inject(SessionService);
  private dialogRef = inject(DialogRef);
  private clientService = inject(ClientService);

  selectables = computed(() =>
    buildClientTree(this.clientService.clientList() ?? [], this.sessionService.client()?.id),
  );

  select(selection: SelectableMapped | undefined) {
    if (selection) {
      this.sessionService.switchClient(selection);
    } else {
      this.sessionService.unsetClient();
    }

    this.close();
  }

  close() {
    this.dialogRef.close();
  }
}
